import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'app-notification-instructions-dialog',
  templateUrl: './notification-instructions-dialog.component.html',
  styleUrls: ['./notification-instructions-dialog.component.scss'],
})
export class NotificationInstructionsDialogComponent implements OnInit {
  browserInstructionsTitle: string = '';
  browserInstructionsSteps: string[] = [];
  image: any;

  constructor(private _transloco: TranslocoService) {}

  ngOnInit(): void {
    this.generateBrowserInstructions();
  }

  private generateBrowserInstructions(): void {
    this.browserInstructionsTitle = this._transloco.translate('notification.blocked.instructions');

    const userAgent = navigator.userAgent;

    if (userAgent.includes('Edg')) {
      this.browserInstructionsSteps = [
        this._transloco.translate('Click the lock icon to the left of the address bar.'),
        this._transloco.translate('Select Permissions for this site.'),
        this._transloco.translate('Find Notifications and set it to Allow.'),
        this._transloco.translate('Refresh the page.'),
      ];
      this.image = 'assets/tour-guides/edge-notifications.gif';
    } else if (userAgent.includes('Firefox')) {
      this.browserInstructionsSteps = [
        this._transloco.translate('Click the message icon to the left of the address bar.'),
        this._transloco.translate("Click 'Allow'."),
        this._transloco.translate('Refresh the page.'),
      ];
      this.image = 'assets/tour-guides/firefox-notifications.gif';
    } else if (userAgent.includes('Safari') && userAgent.includes('Mac OS')) {
      this.browserInstructionsSteps = [
        this._transloco.translate('Go to Safari > Preferences > Websites.'),
        this._transloco.translate('Select Notifications on the left sidebar.'),
        this._transloco.translate('Find this site in the list and change it to Allow.'),
        this._transloco.translate('Refresh the page.'),
      ];
    } else if (userAgent.includes('Chrome')) {
      this.browserInstructionsSteps = [
        this._transloco.translate('Click the toggle icon to the left of the address bar.'),
        this._transloco.translate('Select Site settings.'),
        this._transloco.translate('Find Notifications and set it to Allow.'),
        this._transloco.translate('Refresh the page.'),
      ];
      this.image = 'assets/tour-guides/chrome-notifications.gif';
    } else {
      this.browserInstructionsSteps = [
        this._transloco.translate(
          "Please check your browser's notification settings to enable notifications for this site.",
        ),
      ];
    }
  }
}
